import { debounce } from 'lodash';

export const debounceSearch = debounce(async ({
  commit,
  page,
  state,
  onSearch,
}) => {
  // update page details
  commit('UPDATE_PAGE', page);

  // loadSeed ensures we display only final request results
  const loadSeed = Math.random();
  commit('LOAD_SEED_ADD', loadSeed);

  try {
    // run query off state of page
    const pageIndex = state.page.number - 1;
    const pageSize = state.page.size;
    const { count, result } = await onSearch({
      limit: pageSize,
      offset: pageSize * pageIndex,
    });

    const [finalSeed] = state.loadSeeds.slice(-1);
    if (finalSeed === loadSeed) {
      // remove all seeds
      commit('LOAD_SEED_CLEAR');

      // update state with result
      commit('LOAD', result);
      commit('UPDATE_PAGE', {
        recordCount: count,
      });
    }
  } catch (e) {
    commit('LOAD_SEED_REMOVE', loadSeed);
    promiseError('LIST_LOAD', commit)(e);
  }
}, 500);

export const diffIdsRemoved = (
  currentState: any,
  savedState: any,
) => (
  savedState
    .filter((savedRecord: any) => (
      !currentState.find((currentRecord: any) => (
        currentRecord.id === savedRecord.id
      ))
    ))
    .map((record: any) => record.id)
);

export const promiseError = (
  type: string,
  commit: any,
) => ((error: any) => {
  const payload = { type, error };
  const params = { root: true };
  commit('ERROR', payload, params);
  throw error;
});
